'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _XactlyColors = require('./XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

/**
 * Core theme for Xactly Core Components.
 */
exports['default'] = {
  fontFamily: 'Poppins, Arial, sans-serif',
  fontSize: '14px',
  xSmallSize: '72px',
  smallSize: '120px',
  mediumSize: '200px',
  largeSize: '472px',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  colorPalettePrimary: _XactlyColors2['default'].xCore,
  colorPaletteSecondary: _XactlyColors2['default'].xPlum,
  colorPaletteTertiary: _XactlyColors2['default'].xSoothe,
  colorPalettePrimaryLight: _XactlyColors2['default'].xSky,
  colorPaletteLively: _XactlyColors2['default'].xLively,
  colorTextDark: _XactlyColors2['default'].xCoal,
  colorTextModerate: _XactlyColors2['default'].xCoalModerate,
  colorTextLight: _XactlyColors2['default'].xCoalLight,
  colorBackground: _XactlyColors2['default'].xGroundedLight,
  colorBackgroundLight: _XactlyColors2['default'].xPure,
  colorBackgroundDark: _XactlyColors2['default'].xGrey,
  colorHealthGreen: _XactlyColors2['default'].xGreenery,
  colorHealthUrgent: _XactlyColors2['default'].xUrgent,
  colorHealthGood: _XactlyColors2['default'].xSuccess,
  colorHealthModerate: _XactlyColors2['default'].xSunshine,
  colorHealthPoor: _XactlyColors2['default'].xAlert,
  colorBorderDark: _XactlyColors2['default'].xGrounded,
  colorBorder: _XactlyColors2['default'].xGreyLight,
  colorBorderLight: _XactlyColors2['default'].xGroundedLight,
  colorLink: _XactlyColors2['default'].xGrounded,
  colorDropdownBackground: _XactlyColors2['default'].xPure,
  colorDropdownBackgroundActive: _XactlyColors2['default'].xSootheLight,
  colorButtonPrimary: _XactlyColors2['default'].xCore,
  colorTableBackground: _XactlyColors2['default'].xGroundedLight,
  colorTableBorder: _XactlyColors2['default'].xGrey,
  checkbox: {
    disabled: _XactlyColors2['default'].xGreyDark,
    checked: _XactlyColors2['default'].xSky,
    unchecked: _XactlyColors2['default'].xCoalLight
  },
  radioButton: {
    disabled: _XactlyColors2['default'].xGreyDark,
    checked: _XactlyColors2['default'].xSky,
    unchecked: _XactlyColors2['default'].xCoalLight
  },
  focusBackgroundColor: _XactlyColors2['default'].xSootheLight
};